export default __webpack_public_path__ + "static/media/63DA021E-CDEC-4255-88F2-74DC9F353809_1_105_c.7e65250a.jpeg";